import { capitalize } from 'remeda'

const knownProtocolLabels: Record<string, string> = {
  psm: 'PSM',
  psm3: 'PSM3',
  sparklend: 'SparkLend',
  morpho: 'Morpho',
  maple: 'Maple',
}

export function mapProtocolToLabel(protocol: string): string {
  return knownProtocolLabels[protocol.toLowerCase()] ?? capitalize(protocol)
}
